// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tutorial-card {
  background: var(--app-white);
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 8px var(--app-ink-alpha-100);
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  box-sizing: border-box;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tutorial-card-fullscreen {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  max-width: none;
  border-radius: 0;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  background-color: var(--app-white);
  overflow: hidden;
}

.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 ratio */
  height: 0;
  overflow: hidden;
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

/* Quando estiver em fullscreen */
.tutorial-card-fullscreen .video-container {
  flex: 1;
  width: 100%;
  height: 100%;
  padding: 0;
  position: relative;
}

.tutorial-card-fullscreen .video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/tutorial-card/tutorial-card.component.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,8CAA8C;EAC9C,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB,EAAE,eAAe;EACvC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;AACnB","sourcesContent":[".tutorial-card {\n  background: var(--app-white);\n  border-radius: 8px;\n  padding: 1rem;\n  box-shadow: 0 2px 8px var(--app-ink-alpha-100);\n  width: 100%;\n  max-width: 600px;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.tutorial-card-fullscreen {\n  width: 100vw;\n  height: 100vh;\n  margin: 0;\n  padding: 0;\n  max-width: none;\n  border-radius: 0;\n  box-shadow: none;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--app-white);\n  overflow: hidden;\n}\n\n.video-container {\n  position: relative;\n  width: 100%;\n  padding-bottom: 56.25%; /* 16:9 ratio */\n  height: 0;\n  overflow: hidden;\n}\n\n.video-container iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n/* Quando estiver em fullscreen */\n.tutorial-card-fullscreen .video-container {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  position: relative;\n}\n\n.tutorial-card-fullscreen .video-container iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  object-fit: cover;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
